import { useState, useEffect } from "react";

const slides = [
 {
  image: "https://www.executivecentre.com/_next/image/?url=https%3A%2F%2Fassets.executivecentre.com%2Fassets%2FPrivateOffice-IN-OfficeComboPromo.jpg&w=3840&q=75",
  heading: "Welcome to PC Enterprises",
  quote:"Built on trust. Driven by innovation. Committed to excellence.",
},
{
  image: "https://snnfoods.com/cdn/shop/articles/snn-blog-1-image-151086.jpg?v=1710844801",
  heading: "Authorized C&F Partner for DS Group",
  quote:
    "Official Carrying & Forwarding partner for Spiceco FMCG products, delivering efficient warehousing and seamless distribution services.",
},
{
  image: "/img.png",
  heading: "Distribution of Millets – Healthy Cookie Range",
  quote:
    "Wholesome millet cookies crafted for better digestion and sustained energy, packed with high fiber, plant protein, and essential minerals.",
},
 {
  image: "/exporthome.jpeg",
  heading: "Expanding Trade Across Borders",
  quote:
    "Empowering businesses with seamless global trade and delivering products worldwide with professionalism ",
}
 
];

const Slider = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="relative w-full h-[85vh] lg:h-screen overflow-hidden">

      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ease-in-out
          ${index === current ? "opacity-100 z-10" : "opacity-0 z-0"}`}
        >
          {/* Background Image */}
          <img
            src={slide.image}
            alt={slide.heading}
            className={`w-full h-full object-cover object-center transition-transform duration-[4000ms]
            ${index === current ? "scale-100" : "scale-110"}`}
            loading="eager"
          />

          {/* Overlay */}
          <div className="absolute inset-0 bg-black/60 flex flex-col items-center justify-center text-center px-6">

            {/* Heading */}
            <h1
              className={`text-white font-bold mb-4 transition-all duration-1000
              text-3xl sm:text-4xl md:text-6xl
              ${index === current
                ? "opacity-100 translate-y-0"
                : "opacity-0 -translate-y-10"}`}
            >
              {slide.heading}
            </h1>

            {/* Quote */}
            <p
              className={`text-gray-200 max-w-2xl italic transition-all duration-1000 delay-200
              text-base sm:text-lg md:text-xl
              ${index === current
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-10"}`}
            >
              “{slide.quote}”
            </p>
          </div>
        </div>
      ))}

      {/* Navigation Dots */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex space-x-3">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300
            ${index === current
              ? "bg-white scale-125"
              : "bg-white/50 hover:bg-white/80"}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Slider;